import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableStatusRow from "../../../components/TableStatusRow/TableStatusRow";
import StatusChip from "../../../components/StatusChip/StatusChip";

const PATIENT_TABLE_COLUMN_COUNT = 11;

const PatientTableRows = ({
  rows,
  page,
  rowsPerPage,
  totalRows,
  onView,
  formatDuration,
  onChangePage,
  onChangeRowsPerPage,
  isLoading,
  fetchError,
  onRetry,
}) => {
  return (
    <div>
      <div>
        <div className="table-container">
          <TableContainer>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell>SL NO</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Device Status</TableCell>
                  <TableCell>Email ID</TableCell>
                  <TableCell>Total Hours</TableCell>
                  <TableCell>Total Data Size</TableCell>
                  <TableCell>25 Hz Reg</TableCell>
                  <TableCell>25 Hz Raw</TableCell>
                  <TableCell>100 Hz Raw</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.length === 0 ? (
                  <TableStatusRow
                    colSpan={PATIENT_TABLE_COLUMN_COUNT}
                    loading={isLoading}
                    error={fetchError}
                    onRetry={onRetry}
                    emptyMessage="No patients found"
                  />
                ) : (
                  rows.map((row, index) => (
                    <TableRow
                      key={row.id}
                      onClick={() => onView(row)}
                      style={{ cursor: "pointer" }}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <span className="patient-name-link">{row.name || "-"}</span>
                      </TableCell>
                      <TableCell>{row.userId || "-"}</TableCell>
                      <TableCell>{row.deviceId || "-"}</TableCell>
                      <TableCell>
                        {row.deviceStatus ? (
                          <StatusChip
                            label={row.deviceStatus}
                            tone={
                              row.deviceStatus === "Device Assigned"
                                ? "positive"
                                : "neutral"
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell>{row.email || "-"}</TableCell>
                      <TableCell>
                        {formatDuration(row.totalDuration || "-")}
                      </TableCell>
                      <TableCell>{row.totalDataSize || "-"}</TableCell>
                      <TableCell>
                        {formatDuration(row.totalRegular25Hz || "-")}
                      </TableCell>
                      <TableCell>
                        {formatDuration(row.totalRaw25Hz || "-")}
                      </TableCell>
                      <TableCell>
                        {formatDuration(row.totalRaw100Hz || "-")}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </div>
    </div>
  );
};

export default PatientTableRows;
